import { useContext } from "react";
import { EmailTemplateContext } from "../EmailTemplateContext";
import { ButtonElement } from "../elements/ButtonElement";
import { Mailtext } from "../elements/Mailtext";
import { Plaintext } from "../elements/Plaintext";

export const NewMentorRequest = () => {
  const ctx = useContext(EmailTemplateContext);

  if (!ctx) return null;

  const {
    data,
    template: { template },
  } = ctx;

  return (
    <>
      <Plaintext template={template[1]!} innerRef={data.current[1]} />
      <Plaintext template={template[2]!} innerRef={data.current[2]} />
      <Plaintext template={template[3]!} innerRef={data.current[3]} />
      {template[4]?.type === "button" ? (
        <ButtonElement template={template[4]} innerRef={data.current[4]} />
      ) : (
        <Plaintext template={template[4]!} innerRef={data.current[4]} />
      )}
      <Plaintext template={template[5]!} innerRef={data.current[5]} />
      {template[6]?.text && (
        <>
          <Mailtext template={template[6]} innerRef={data.current[6]} />
          <Plaintext template={template[7]!} innerRef={data.current[7]} />
          <Plaintext template={template[8]!} innerRef={data.current[8]} />
        </>
      )}
    </>
  );
};
